import z from 'zod';
import {tradeTagDbSchema} from './tradeTagDbSchema';

export const tradeTagWriteSchema = tradeTagDbSchema;

export interface TradeTagWrite extends z.infer<typeof tradeTagWriteSchema> {}
